import React, { useState, useEffect } from "react";
import { logout } from "../store/actions/session";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Box,
  IconButton,
  Drawer,
  List,
  ListItem,
  Hidden,
} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import { ButtonDanger } from "../ui/templates/buttons";

const RouterNav = ({ router, href = "/#404", title = "title" }) => {
  const active = router.location.hash.startsWith(href);

  const navStyle = {
    backgroundColor: active ? "#F7F7F7" : "transparent",
    border: "1px solid #DCDCDC",
  };

  const indicatorStyle = {
    backgroundColor: active ? "#E00000" : "transparent",
    width: "4px",
    height: "50px",
    position: "absolute",
    left: "-10px",
    top: "0px",
  };

  const menuItemStyle = {
    color: "#000000",
    fontWeight: 400,
    fontSize: "18px",
    padding: "16px",
    marginLeft: "10px",
    lineHeight: "100%",
    position: "relative",
    width: "180px",
  };

  return (
    <>
      <a href={href} style={{ textDecoration: "none" }}>
        <Box style={navStyle} className="navStyle">
          <Box style={menuItemStyle} className="menuItemStyle">
            {active && (
              <Box style={indicatorStyle} className="indicatorStyle" />
            )}
            {title}
          </Box>
        </Box>
      </a>
    </>
  );
};

function Header({ session, router, logout }) {
  const [openDrawer, setOpenDrawer] = useState(false);

  const handleDrawerToggle = () => {
    setOpenDrawer(!openDrawer);
  };
  const handleLogout = () => {
    setOpenDrawer(false);
    logout();
    localStorage.setItem("isLogin", null);
  };
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 600) {
        setOpenDrawer(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <Box>
      {session && (
        <Hidden only={["lg", "xl"]}>
          <IconButton
            className="hamburgerBtn"
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerToggle}
          >
            <MenuIcon style={{ color: "black" }} />
          </IconButton>
        </Hidden>
      )}

      <Drawer anchor="left" open={openDrawer} onClose={handleDrawerToggle}>
        <List>
          {session && (
            <>
              <ListItem button>
                <RouterNav router={router} href={"#/profile"} title="Profile" />
              </ListItem>
              <ListItem button>
                <RouterNav router={router} href={"#/events"} title="Events" />
              </ListItem>
              <ListItem button>
                <RouterNav router={router} href={"#/teams"} title="Teams" />
              </ListItem>
              <ListItem button>
                <RouterNav
                  router={router}
                  href={"#/sponsors"}
                  title="Member Benefits"
                />
              </ListItem>
              <ListItem>
                <ButtonDanger text="Logout" onClick={handleLogout} />
              </ListItem>
            </>
          )}
        </List>
      </Drawer>
      <Hidden only={["sm", "xs", "md"]}>
        <Box>
          {session && (
            <>
              <RouterNav router={router} href="#/profile" title="Profile" />
              <RouterNav router={router} href="#/events" title="Events" />
              <RouterNav router={router} href="#/teams" title="Teams" />
              <RouterNav
                router={router}
                href="#/sponsors"
                title="Member Benefits"
              />
              <ListItem className="logoutBtn">
                  <ButtonDanger
                    teamFullWidth
                    text="Logout"
                    onClick={handleLogout}
                  />
              </ListItem>
            </>
          )}
        </Box>
      </Hidden>
    </Box>
  );
}

const mapStateToProps = (state) => ({
  session: state.session,
  router: state.router,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ logout }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Header);
